import React from 'react';
import { Form, TextAreaBox } from 'fw/forms';
import { Col, Modal, FormGroup, Row, Button } from 'react-bootstrap';

class DenyCommentPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,

            saving: false,
            loadingData: false,

            buttons: {
                save: { disabled: false }
            },

            form: {
                comments: null
            },

            entityId: 0
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            saving: false
        });
    }

    handleAdd = () => {
        const me = this;

        let comments = null;
        if (this.props.comments)
            comments = this.props.comments;

        this.setState({
            saving: false,
            form: {
                ...this.state.form,
                comments: comments,
                content: this.state.form.comments,
                original: {
                    ...this.state.form,
                }
            }
        }, () => {
            if (me.props.onSave)
                me.props.onSave(me.state.form);
            me.close();
        });
    }

    close = () => {
        this.setState(this.initialState(this.props), function () {
            this.props.onClose();
        });
    }

    handleChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    renderCommentsSection() {
        return (
            <React.Fragment>
                <FormGroup>
                    {this.props.formLabel}
                    <TextAreaBox name="comments"
                        placeholder="Enter your comments here..."
                        required
                        maxLength={2500} />
                </FormGroup>
            </React.Fragment>
        )
    }

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close} backdrop="static">
                <Modal.Header>
                    {this.props.header}
                </Modal.Header>
                <Modal.Body>
                    <Form
                        onChange={this.handleChange}
                        values={this.state.form}
                        ref={(form) => { this._form = form }}>
                        <Row>
                            <Col sm={12}>
                                {this.renderCommentsSection()}
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="link" onClick={this.close} autoFocus>Cancel</Button>
                    <Button bsStyle="primary"
                        disabled={this.state.saving}
                        onClick={this.handleAdd}>
                        Add Comment & Save
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export default DenyCommentPopUp;

// Default properties
DenyCommentPopUp.defaultProps = {
    commentTypeCode: 'NOR'
}


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/DenyCommentPopUp.js